<template>
	<div class="volunteers">
		<egranty-section-divider
			text="Wolontariusze"
			icon="people"
			:show-print-info="showPrintInfo"
		></egranty-section-divider>
		<v-container>
			<v-form ref="form">
				<v-layout row wrap>
					<egranty-text-input-field
						v-if="!readonly"
						style="margin:0"
						v-model="code"
						label="Kod wolontariusza"
						for="choose-volunteers-start-volunteering"
						id="choose-volunteers-start-volunteering"
					></egranty-text-input-field>
					<v-flex>
						<offer-button
							color="primary"
							v-if="!readonly && this.data.length < volunteerLimit"
							:disabled="code === ''"
							text="Dodaj wolontariusza"
							icon="add"
							@click="addVolunteer()"
						></offer-button>
					</v-flex>
				</v-layout>

				<div v-if="data.length === 0 && !readonly">
					<v-alert
						:value="true"
						type="info"
						color="info"
					>Brak podanych wolontariuszy!
					</v-alert>
				</div>
				<div v-else-if="data.length === 0 && readonly">
					Udział wolontariuszy nie jest przewidziany.
				</div>

				<div v-for="(v, index) in data" :key="index" class="mt-3 volunteer">
					<v-layout row>
						<h4 class="mr-2">{{1+index}}.</h4>
						<div>
							<strong>{{v.name}} {{v.surname}}</strong>&nbsp;&nbsp;({{v.email}})
							<v-icon small class="ml-5" v-if="!readonly"
								color="lightred"
								@click="removeVolunteer(index)" title="Usuń wolontariusza">
								delete
							</v-icon>
						</div>
					</v-layout>
					<v-layout row mt-2 ml-4>
						<div>
							<strong>Dane teleadresowe:</strong> {{v.address.street}}
							{{v.address.building}}{{v.address.apartment === '' || v.address.apartment
								=== null ? '' : '/' + v.address.apartment}}, {{v.address.postalCode}}
							{{v.address.city}}{{v.phoneNumber === undefined ? "" : ", tel. " + v.phoneNumber}}
						</div>
					</v-layout>
					<v-layout row mt-2 ml-4>
						<div>
							<strong>Liczba dni wolontariatu:</strong> {{getTotalDaysAbroad(v)}}
						</div>
					</v-layout>
					<v-layout row mt-2 ml-4 v-for="(vt, termIndex) in v.volunteeringTerms" :key="termIndex">
						<egranty-date-picker
							label="Początek wolontariatu"
							v-model="vt.volunteeringStartDate"
							:min="getMinStartDate(vt, termIndex)"
							:max="getMaxStartDate(vt, termIndex)"
							:disabled="readonly"
						/>
						<egranty-date-picker
							label="Koniec wolontariatu"
							v-model="vt.volunteeringEndDate"
							:min="getMinEndDay(vt, termIndex)"
							:max="getMaxEndDate(vt, termIndex)"
							:disabled="readonly"
						/>
						<v-tooltip bottom v-if="!readonly">
							<template v-slot:activator="{ on }">
								<v-btn icon
									@click="deleteTerm(v, termIndex)">
									<v-icon small v-on="on" color="red">
										delete
									</v-icon>
								</v-btn>
							</template>
							<span>Usuń termin</span>
						</v-tooltip>
					</v-layout>
					<v-btn @click="addNewTerm(v)" v-if="!readonly" class="ml-4">
						dodaj kolejny termin
					</v-btn>
				</div>
			</v-form>

			<div v-if="data.length !== 0 || !readonly" :class='{notChecked: !globalInitiative.isGlobal}'>
				<v-checkbox
					v-model="globalInitiative.isGlobal"
					label="W projekcie jest realizowana inicjatywa edukacyjna"
					:disabled="readonly"
					@change="globalInitiativeChanged"
					aria-label="global initiative">
				</v-checkbox>
			</div>

			<div v-if="globalInitiative.isGlobal" class="desc-educational-initiative">
				<v-textarea
					browser-autocomplete="off"
					aria-label="global initiative description"
					v-model="globalInitiative.description"
					label="Opis inicjatywy edukacyjnej"
					maxlength="2000"
					counter="2000"
					@change="globalInitiativeChanged"
					:disabled="readonly"
					auto-grow
					class="no-print"
				/>
				<div class="div-for-print"><p><strong style="font-size: 12px">Opis inicjatywy edukacyjnej</strong></p>
					{{globalInitiative.description}}
				</div>
			</div>

			<egranty-validation-error
				:error="error"
			></egranty-validation-error>
		</v-container>
	</div>
</template>

<script>
	import EgrantySectionDivider from "../../../../genericComponents/EgrantySectionDivider";
	import EgrantyTextInputField from "../../../../genericComponents/EgrantyTextInputField";
	import EgrantyValidationError from "../../../../genericComponents/EgrantyValidationError";
	import {Volunteer} from "../../../../api/generated/Volunteer";
	import OfferButton from "../../offer/components/OfferButton";
	import EgrantyDatePicker from "../../../../genericComponents/EgrantyDatePicker";


	export default {
		name: "ChooseVolunteers",
		components: {
			EgrantyDatePicker,
			EgrantyValidationError,
			EgrantyTextInputField,
			EgrantySectionDivider,
			OfferButton,
		},

		data() {
			return {
				volunteer: {
					address: {
						apartment: "",
						building: "",
						city: "",
						postalCode: "",
						street: ""
					},
					name: "",
					surname: "",
					email: "",
					volunteerCode: "",
					volunteeringTerms: [],
					volunteeringStartDate: "",
					volunteeringEndDate: ""
				},
				globalInitiative: {
					isGlobal: false,
					description: ''
				},
				code: "",
				startDate: "",
				endDate: "",
				data: [],
				error: ""
			};
		},

		methods: {

			validate() {
				this.error = "";

				if (this.volunteersRequired && !this.data.length) {
					this.error = " Udział wolontariuszy jest obowiązkowy!";
					return false;
				}

				// walidacja terminów wolontariuszy
				for (let iv = 0; iv < this.data.length; iv++) {
					let volunteer = this.data[iv];
					if (volunteer.volunteeringTerms === null || volunteer.volunteeringTerms.length === 0) {
						this.error = "Wolontariusz musi mieć co najmniej jeden termin wolontariatu";
						return false;
					}
					for (let ivt = 0; ivt < volunteer.volunteeringTerms.length; ivt++) {
						let vt = volunteer.volunteeringTerms[ivt];
						if (vt.volunteeringStartDate === null || vt.volunteeringEndDate === null) {
							this.error = "Proszę zaznaczyć brakujące daty w terminach wolontariatu";
							return false;
						}
						//Sprawdzanie czy terminy się nie przeplatają
						for (let subIvt = ivt + 1; subIvt < volunteer.volunteeringTerms.length; subIvt++) {
							if (!this.areVolunteeringTermsRangesIndependent(vt, volunteer.volunteeringTerms[subIvt])) {
								this.error = "Terminy wolontariatu muszą być rozłączne";
								return false;
							}
						}
					}

					if (this.getTotalDaysAbroad(volunteer) < this.minDaysAbroad - 1) {
						this.error = "Minimalna liczba dni za granicą: " + this.minDaysAbroad;
						return;
					}
				}

				if (this.globalInitiative.isGlobal && (this.globalInitiative.description === null || !this.globalInitiative.description.length > 0)) {
					this.error = " Proszę uzupełnić pole opis inicjatywy edukacyjnej!";
					return false;
				}

				return true;
			},

			uniqueVolunteer(code) {
				return !this.data.map(volunteer => volunteer.volunteerCode).includes(code);
			},

			addVolunteer() {
				Volunteer.getVolunteerOfferData(this, this.code, successResponse => {
						if (typeof successResponse !== "object") {
							this.error = "Błędny kod wolontariusza";
							return;
						}
						if (!this.uniqueVolunteer(successResponse.volunteerCode)) {
							this.error = "Wolontariusz już jest dodany do listy";
							return;
						}
						successResponse.volunteeringTerms = [{volunteeringStartDate: null, volunteeringEndDate: null}];
						this.data.push(successResponse);
						this.code = "";
						this.sync();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się pobrać danych wolontariusza", errorResponse);
					});
			},

			getTotalDaysAbroad(volunteer) {
				let totalDays = 0;
				volunteer.volunteeringTerms.forEach(volunteer => {
					if (volunteer.volunteeringStartDate !== null && volunteer.volunteeringEndDate !== null) {
						totalDays += 1 + this.getDayDifference(new Date(volunteer.volunteeringStartDate), new Date(volunteer.volunteeringEndDate));
					}
				});
				return totalDays;
			},

			getDayDifference(dt1, dt2) {
				return Math.floor((Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) - Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) / (1000 * 60 * 60 * 24));
			},

			getFormattedDate(date) {
				if (date !== null && date !== undefined) {
					let year = date[0];
					let month = date[1] < 10 ? '0' + date[1] : date[1];
					let day = date[2] < 10 ? '0' + date[2] : date[2];
					return year + "-" + month + "-" + day;
				} else return "";
			},

			removeVolunteer(index) {
				this.data.splice(index, 1);
				this.sync();
			},

			addNewTerm(volunteer) {
				volunteer.volunteeringTerms.push(
					{
						volunteeringStartDate: null,
						volunteeringEndDate: null
					}
				);
			},

			//zwraca true gdy terminy się nie przepletają lub false w przeciwnym przypadku
			areVolunteeringTermsRangesIndependent(volunteeringTerm1, volunteeringTerm2) {
				if ((volunteeringTerm1.volunteeringStartDate >= volunteeringTerm2.volunteeringStartDate &&
					volunteeringTerm1.volunteeringStartDate <= volunteeringTerm2.volunteeringEndDate) ||
					(volunteeringTerm1.volunteeringEndDate >= volunteeringTerm2.volunteeringStartDate &&
					volunteeringTerm1.volunteeringEndDate <= volunteeringTerm2.volunteeringEndDate)) {
					return false;
				} else {
					return true;
				}
			},

			deleteTerm(volunteer, termIndex) {
				volunteer.volunteeringTerms.splice(termIndex, 1);

			},

			getMinStartDate() {
				return this.moduleStartDate;
			},

			getMaxStartDate(volunteeringTerm) {
				return volunteeringTerm.volunteeringEndDate !== null ? volunteeringTerm.volunteeringEndDate : this.moduleEndDate;
			},

			getMinEndDay(volunteeringTerm) {
				return volunteeringTerm.volunteeringStartDate !== null ? volunteeringTerm.volunteeringStartDate : this.moduleStartDate;
			},

			getMaxEndDate() {
				return this.moduleEndDate;
			},

			globalInitiativeChanged() {
				this.$emit("change", this.globalInitiative);
			},

			sync() {
				this.error = "";
				this.$emit("input", this.data);
			},

		},

		watch: {
			value: {
				immediate: true,
				handler(val) {
					if (val === undefined || val === null) {
						val = [];
					}
					this.data = val;
					this.data.forEach(item => {
						if (typeof item.volunteeringStartDate !== 'string')
							item.volunteeringStartDate = this.getFormattedDate(item.volunteeringStartDate);
						if (typeof item.volunteeringEndDate !== 'string')
							item.volunteeringEndDate = this.getFormattedDate(item.volunteeringEndDate);
					});
				},
			},

			globalInit: {
				immediate: true,
				handler(val) {
					this.globalInitiative.isGlobal = val;
				},
			},

			globalInitDescription: {
				immediate: true,
				handler(val) {
					this.globalInitiative.description = val;
				},
			}
		},

		props: {
			readonly: {
				default: false
			},
			moduleStartDate: {
				default: undefined
			},
			moduleEndDate: {
				default: undefined
			},
			numberOfModules: {
				default: 0
			},
			value: Array,
			globalInit: Boolean,
			globalInitDescription: String,
			volunteersRequired: Boolean,
			volunteerLimit: Number,
			minDaysAbroad: Number,
			showPrintInfo: {
				type: Boolean, default: false
			}
		},
	};

</script>

<style scoped>
	.v-btn.v-btn--disabled[data-v-4a0e52ba]:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {
		background-color: #0075E2 !important;
	}

	/* .v-btn.v-btn--disabled .v-icon {
		color: #fff !important;
	} */

</style>
